// extracted by mini-css-extract-plugin
module.exports = {"back__btn":"style_back__btn__33xGy"};